import { Component, ComponentFactoryResolver, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { SvgIconComponentFactory } from 'projects/shared/svg-icons/svg-icon-component-factory';
import { SvgIconHostDirective } from 'projects/shared/svg-icons/svg-icon-host.directive';
import { RealEstateOwnedItem } from '../../../models/real-estate-owned-item-model';
import { EnumsService } from '../../../services/enums.service';
import { ReoExpenseBreakdownComponent } from '../reo-expense-breakdown/reo-expense-breakdown.component';
import Swal from 'sweetalert2';

@Component({
    selector: 'reo-item',
    templateUrl: 'reo-item.component.html',
    standalone: false
})

export class RealEstateOwnedItemComponent implements OnInit {

  private readonly _transloco = inject(TranslocoService);

  @ViewChild(SvgIconHostDirective, {static: true}) svgIconHost!: SvgIconHostDirective;

  @ViewChild(ReoExpenseBreakdownComponent, {static: true})
  reoExpenseBreakdownComponent!: ReoExpenseBreakdownComponent

  constructor(private readonly _svgIconFactory: SvgIconComponentFactory,
    private _componentFactoryResolver: ComponentFactoryResolver,
    private readonly _enumsService: EnumsService) { }

  @Input()
  reoItem!: RealEstateOwnedItem;

  @Output() deleteClicked = new EventEmitter<RealEstateOwnedItem>();
  @Output() editClicked = new EventEmitter<RealEstateOwnedItem>();

  public get isReadOnly(): boolean {
    return this.reoItem.isReadOnly;
  }

  getDeleteClickedEmitter = (): EventEmitter<RealEstateOwnedItem> => {
      return this.deleteClicked;
  }

  getEditClickedEmitter = (): EventEmitter<RealEstateOwnedItem> => {
      return this.editClicked;
  }

  onDeleteClicked = (e: any) => {
    e.cancelBubble = true;
    if(e.stopPropagation) e.stopPropagation();

    Swal.fire({
      title: this._transloco.translate('common.areYouSure'),
      text: this._transloco.translate('wizard.reo.confirmDeleteReo', { address: this.reoItem.address }),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this._transloco.translate('common.yesDeleteIt')
    }).then((result) => {
      if (result.isConfirmed) {
        this.deleteClicked.emit(this.reoItem);
      }
    });
  }

  onEditClicked = () => {
      this.editClicked.emit(this.reoItem);
  }

  public get propertyTypeName(): string {
    return this._enumsService.reoPropertyTypeName(this.reoItem.propertyType!);
  }

  private get iconName(): string {
    return "duotone-home";
  }

  private loadIcon = () => {
    const iconName = this.iconName;
    if (!iconName) {
        return;
    }
    const svgIconComponent = this._svgIconFactory.getSvIconComponent(iconName);
    if (!svgIconComponent) {
        return;
    }
    const componentFactory = this._componentFactoryResolver.resolveComponentFactory(svgIconComponent);

    const viewContainerRef = this.svgIconHost.viewContainerRef;
    viewContainerRef.clear();

    viewContainerRef.createComponent(componentFactory);
  }

  ngOnInit() {
    this.loadIcon();
   }
}
